export const useDefaultData = ({Helpers}) => {

    const {getCurrentDate} = Helpers

    const defaultFormGlobal = {
        idcredito: 0,
        idcotizacion: 0,
        idvehiculo: 0,
        idcliente: 0,
        credito_fecha: getCurrentDate(),
        credito_dia_pago: '',
        monto_venta: '',
        saldo_financiar: '',
        monto_enganche: '',
        enganche: '',
        interes_total: '',
        interes: '',
        plazo: '',
        plazo_anios: '',
        gps: '',
        seguro: '',
        otros: '',
        total_cuota: '',
        cuota_niv: '',
        vigencia_check: '',
        aprobacion_observaciones: '',
        vigencia_fecha: '',
        files: [],
        fileRejections: [],
        acceptedFiles: [],
    }

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormDeposit = {
        idmovimiento: '',
        idcaja: '',
        idbanco: '',
        boleta_numero: '',
        boleta_foto_path: '',
        boleta_foto_originalname: '',
        aprobacion_referencia_ach: '',
        aprobacion_observaciones: '',
        deposito_fecha: getCurrentDate(),
        deposito_moneda: '',
        deposito_monto: '',
        clean_deposito_monto: 0,
        deposito_dolares: '',
        clean_deposito_dolares: 0,
        deposito_quetzales: '',
        clean_deposito_quetzales: 0,
        deposito_observaciones: '',
        deposito_tipo_cambio: 7.8,
        movimiento_tipo: '',
        aprobacion_check: '',
        files: [],
        fileRejections: [],
        acceptedFiles: [],
    }

    const defaultFormPreInventory = {
        idvehicledeposit: 0,
        valor: '',
        marca: '',
        modelo: '',
        linea: '',
        color: '',
        matricula: '',
        chasis: '',
    }
    
    const optionsTypeMoneda = [
        { value: 'QUETZAL', label: 'QUETZAL' },
        { value: 'DOLAR', label: 'DOLAR' },
    ];

    const optionsTypePayment = [
        { value: 'EFECTIVO', label: 'EFECTIVO' },
        { value: 'DEPOSITO', label: 'DEPOSITO' },
    ];

    const optionsAprobacionDeposit = [
        { value: 'APROBADO', label: 'APROBADO' },
        { value: 'PENDIENTE', label: 'PENDIENTE' },
        { value: 'RECHAZADO', label: 'RECHAZADO' },
    ];


    const optionsAprobacionCheck = [
        { value: 'VIGENTE', label: 'VIGENTE' },
        { value: 'FINALIZACION ORDINARIA', label: 'FINALIZACION ORDINARIA' },
    ];

   
    return Object.freeze({
        defaultFormGlobal,
        defaultDataModal,
        defaultFormDeposit,
        optionsTypeMoneda,
        optionsTypePayment,
        optionsAprobacionDeposit,
        defaultFormPreInventory,
        optionsAprobacionCheck,
    })
}